import { render, staticRenderFns } from "./TextControl.vue?vue&type=template&id=754af032&scoped=true&"
import script from "./TextControl.vue?vue&type=script&lang=js&"
export * from "./TextControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754af032",
  null
  
)

export default component.exports